const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const EMPTY = '—';

const toDate = (value) => {
  if (value == null || value === '') return null;
  // Prefer date-only parse for YYYY-MM-DD to avoid UTC shift.
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    const d = new Date(`${value.trim()}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** True when value carries a real clock time (not midnight / date-only). */
export const hasValidTime = (value) => {
  if (value == null || value === '') return false;
  if (typeof value === 'string') {
    const s = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
    // Explicit midnight with optional fractional seconds / timezone → treat as date-only.
    if (/T00:00:00(\.0+)?(Z|[+-]\d{2}:?\d{2})?$/i.test(s.replace(' ', 'T'))) return false;
    if (/[ T]00:00:00(\.0+)?$/.test(s)) return false;
  }
  const d = toDate(value);
  if (!d) return false;
  return d.getHours() !== 0 || d.getMinutes() !== 0 || d.getSeconds() !== 0;
};

/** dd/MMM/yyyy — e.g. 10/Jun/2026 */
export const formatDate = (value, empty = EMPTY) => {
  const d = toDate(value);
  if (!d) return empty;
  const day = String(d.getDate()).padStart(2, '0');
  const month = MONTHS_SHORT[d.getMonth()];
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

/** dd/MMM/yyyy hh:mm a — e.g. 10/Jun/2026 01:45 PM */
export const formatDateTime = (value, empty = EMPTY) => {
  const d = toDate(value);
  if (!d) return empty;
  const day = String(d.getDate()).padStart(2, '0');
  const month = MONTHS_SHORT[d.getMonth()];
  const year = d.getFullYear();
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  if (hours === 0) hours = 12;
  const hh = String(hours).padStart(2, '0');
  return `${day}/${month}/${year} ${hh}:${minutes} ${ampm}`;
};

/**
 * Date columns: show time only when a valid non-midnight time is present.
 * Date: dd/MMM/yyyy | Date+time: dd/MMM/yyyy hh:mm a
 */
export const formatDisplayDate = (value, empty = EMPTY) => {
  if (value == null || value === '') return empty;
  return hasValidTime(value) ? formatDateTime(value, empty) : formatDate(value, empty);
};

export default formatDisplayDate;
